<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/jointop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会</div>
            <div class="ziti">中国医药卫生文化协会</div>
            <!-- <div class="ziti">中国抗衰老促进会</div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">承办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会专家工作委员会</div>
            <div class="ziti">中国医药教育协会皮肤与健康教育专业委员会</div>
            <div class="ziti">复旦大学附属华山医院</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">报到时间</div>
                </div>
            </div>
            <div class="neirong ziti">2025年8月22日全天</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议时间</div>
                </div>
            </div>
            <div class="neirong ziti">2025年8月23日至24日</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会场信息</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="perplebold">会议地点：</span>上海光大会展中心国际大酒店</div>
                <div class="name"><span
                        class="perplebold">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span>中国上海市徐汇区漕宝路66号</div>
            </div>
            <img src="../../assets/images/acmedpos.png" alt="" class="posimg">
            <!-- <div class="mapview" @click="goapp(31.167118, 121.4263217, '光大会展中心国际大酒店')">
                <el-amap class="amap-box" :vid="'amap-vue'" @init="handleMapInit" :zoom="zoom" :center="position">
                    <el-amap-marker :vid="'marker'" :position="position" :events="events" ref="map"></el-amap-marker>
                </el-amap>
            </div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle1">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">重要时间与地点</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name nameflex">
                    <div class="perplebold">报&nbsp;&nbsp;&nbsp; 到&nbsp;&nbsp;&nbsp;
                        时&nbsp;&nbsp;&nbsp;间：</div>
                    <div>2025年8月22日 09:00-18:00<br />1F注册区</div>
                </div>
                <div class="name"><span class="perplebold">专委会全体会议：</span>2025年8月22日</div>
                <div class="name"><span class="perplebold">大&nbsp;会&nbsp; 开&nbsp; 幕&nbsp; 式：</span>2025年8月23日</div>
                <div class="name"><span class="perplebold">大&nbsp;会&nbsp; 闭&nbsp; 幕&nbsp; 式：</span>2025年8月24日</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">讲者须知</div>
                </div>
            </div>
            <ul class="neirong1">
                <li class="name">请根据日程内的发言时间提前到达您的学术任务的会场</li>
                <li class="name">为保证本次大会的顺利进行，请讲者<span class="perplebold">不要使用自己的电脑</span></li>
                <li class="name">讲者发言的幻灯片请使用<span class="perplebold">MS OFFICE PowerPoint</span>格式<span
                        class="perplebold">比例16:9</span></li>
                <li class="name">讲者请<span class="perplebold">提前3小时</span>到达大会试片室，工作人员会协助您测试幻灯片并拷贝至工作电脑中
                </li>
                <li class="name">讲者幻灯片在您发言后工作人员会删除，禁止拷贝</li>
            </ul>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主持人须知</div>
                </div>
            </div>
            <ul class="neirong1">
                <li class="name">请根据日程内的学术任务时间提前到达指定会场</li>
                <li class="name">请<span class="perplebold">严格控制讲者发言时间</span>，适时提醒讲者准时完成发言</li>
                <li class="name">请按照日程组织主题讨论，控制会场秩序</li>
                <li class="name">如遇特殊情况请与会场工作人员联系</li>
            </ul>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">住宿须知</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name2"><span class="perplebold">入住与退房时间</span></div>
                <div class="name2">会议酒店入住时间为入住当日14:00后，退房时间为退房当日12:00前</div>
                <div class="name2"><span class="perplebold">关于住宿费发票</span></div>
                <div class="name2">会议住宿发票由入住酒店开具</div>
            </div>
        </div>

        <div class="model1">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">温馨提示</div>
                </div>
            </div>
            <ul class="neirong1">
                <li class="name">请不要在会场内及入住酒店内吸烟</li>
                <li class="name">会场内请将手机调至静音或震动模式</li>
                <li class="name">根据规定上海地区酒店不会主动在房间内放置洗漱用品，请需要使用的代表主动向酒店提出需求</li>
                <li class="name">请根据垃圾分类的要求将垃圾分类好再丢弃至相应的垃圾箱</li>
                <li class="name">会议期间如您有身体不适，请联系大会工作人员或至大会服务中心</li>
                <li class="name">会议期间注意安全，遵守秩序</li>
            </ul>
        </div>
        <div class="lasttext darkperplebold">参会指南陆续更新中……</div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'joinmeeting',
    data() {
        return {
            map: null,
            zoom: 17,
            position: [121.4263217, 31.167118],
            events: {},
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
    margin-bottom: 0.2rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitle1 {
    background: rgb(0, 53, 133);
    width: 45%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.08rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    // padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin: auto;
    margin-top: 0.3rem;
    width: 95%;
}

.neirong1 {
    margin: auto;
    margin-top: 0.3rem;
    width: 88%;
    list-style: decimal;
}

.ziti {
    font-size: .37rem;
    width: 95%;
    margin: auto;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
    margin: 0.08rem 0;
}

.name2 {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
    margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.darkperplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.mapview {
    width: 90%;
    margin: auto;
    height: 5.5rem;
    margin-top: 0.5rem;
}

.lasttext {
    width: 100%;
    text-align: center;
    margin-top: .5rem;
    padding-bottom: 1rem
}

.nameflex {
    display: flex;
    flex-direction: row;
}

.posimg {
    width: 100%;
    margin-top: 0.5rem;
}
</style>